<template>
  <div>
    <b-card>
      <div>
        <validation-observer
          ref="checklistRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="8"
              class="mb-2"
            >
              <h5 class="mb-0">
                Checklist Details
              </h5>
              <small class="text-muted">
                Enter Title and Checklist Items.
              </small>
            </b-col>
            <b-col
              cols="4"
              class="mb-2"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="validationForm"
              >
                <span>Submit</span>
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-secondary"
                class="ml-2"
                :to="{ name: 'manage-checklist' }"
              >
                <feather-icon
                  icon="RevertIcon"
                  class="mr-25"
                />
                <span>Back To list</span>
              </b-button>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Title"
                label-for="title"
              >
                <validation-provider
                  #default="{ errors }"
                  name="title"
                  rules="required"
                >
                  <b-form-input
                    id="title"
                    v-model="data_local.title"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Checklist Title"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-lg-2"
                @click="repeateAgain"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
                />
                <span>Add New</span>
              </b-button>
            </b-col>
          </b-row>
          <b-form
            ref="form"
            :style="{height: trHeight}"
            class="repeater-form"
            @submit.prevent="repeateAgain"
          >

            <!-- Row Loop -->
            <b-row
              v-for="(item, index) in items"
              :id="item.id"
              :key="item.id"
              ref="row"
            >

              <!-- Item Name -->
              <b-col md="10">
                <b-form-group
                  label="Checklist Items"
                  label-for="checklist-items"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="checklist item"
                    rules="required"
                  >
                    <b-form-textarea
                      v-model="data_local.descriptions[index]"
                      placeholder="Enter New Checklist Items"
                      :state="errors.length > 0 ? false:null"
                    >
                      <small
                        class="text-danger"
                      >{{ errors[0] }}</small>
                    </b-form-textarea>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Remove Button -->
              <b-col
                lg="2"
                md="3"
                class="mb-50"
              >
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-0 mt-md-2"
                  @click="removeItem(index)"
                >
                  <feather-icon
                    icon="TrashIcon"
                  />
                </b-button>
              </b-col>
              <b-col cols="12">
                <hr>
              </b-col>
            </b-row>

          </b-form>
        </validation-observer>
      </div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="mt-lg-2"
        @click="repeateAgain"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
        <span>Add New</span>
      </b-button>
    </b-card>
  </div>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BRow, BCol, BButton, BCard, BFormTextarea,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import employeeStoreModule from '../../employeeStoreModule'

export default {
  components: {
    BForm,
    BRow,
    BCard,
    BCol,
    BButton,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      required,
      data_local: {
        title: '',
        descriptions: [],
      },
      items: [{
        id: 1,
      }],
      nextTodoId: 2,
    }
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'app-employees'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, employeeStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })
  },
  methods: {
    validationForm() {
      const self = this
      return new Promise((resolve, reject) => {
        self.$refs.checklistRules.validate().then(success => {
          if (success) {
            self.$store.dispatch('app-employees/addChecklist', self.data_local)
              .then(res => {
                if (res.data.success) {
                  // self.$toast({
                  //   component: ToastificationContent,
                  //   props: {
                  //     title: 'Checklist Added',
                  //     icon: 'BellIcon',
                  //     variant: 'success',
                  //     text: res.data.message,
                  //   },
                  // })

                  this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Checklist Added',
                icon: 'BellIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
                  self.$router.push('/manage/checklist')
                } else {
                  // self.$toast({
                  //   component: ToastificationContent,
                  //   props: {
                  //     title: 'Oops! Checklist Adding Failed',
                  //     icon: 'BellIcon',
                  //     variant: 'danger',
                  //     text: res.data.message,
                  //   },
                  // })

                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Oops! Checklist Adding Failed',
                      icon: 'BellIcon',
                      variant: 'danger',
                      text: res.data.message,
                    },
                  }, {
                    timeout: 2000, 
                    position: 'bottom-center',
                    toastClassName:"radius-8 error-info ",
                    hideProgressBar : true,
                  });
                }
              })
              .catch(error => {
                console.log(error)
                // self.$toast({
                //   component: ToastificationContent,
                //   props: {
                //     title: 'Oops! Checklist Adding Failed',
                //     icon: 'BellIcon',
                //     variant: 'danger',
                //     text: error,
                //   },
                // })
                this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Oops! Checklist Adding Failed',
                      icon: 'BellIcon',
                      variant: 'danger',
                      text: error,
                    },
                  }, {
                    timeout: 2000, 
                    position: 'bottom-center',
                    toastClassName:"radius-8 error-info ",
                    hideProgressBar : true,
                  });
              })
          } else {
            reject()
          }
        })
      })
    },
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.items.splice(index, 1)
      this.data_local.descriptions.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
    .repeater-form {
        overflow: hidden;
        transition: .35s height;
    }
</style>
